import React from 'react';
import { Link } from 'react-router-dom';
import { Collapse } from 'antd';
import { Footer , Header} from '../index';
import './licence.css'


const items = [
  {
    key: '1',
    label:'Licence Sciences de l\'Informatique', 
    children: 
          <div>
                <p>   <span className='sous-title'>Plan d'études : </span>
                     <Link to='/Licences'><span >Cliquer ici</span></Link> </p> 
          </div>
,
  },
  {
    key: '2',
    label: 'Licence Mathématiques Appliquées',
    children:<p> 
            <h6>DESCRIPTION</h6> <br/>
            Contrairement aux idées reçues, la licence de mathématiques n’aboutit pas uniquement à l’enseignement ou à la recherche. Les débouchés sont nombreux. <br/>
          Météorologie, finance, banque, assurance, médecine, biologie, fiabilité, transport… Vous n’imaginez pas tous les secteurs dans lesquels vous pourrez travailler en
          suivant des études de mathématiques ! Cependant, la Licence n’est généralement pas suffisante pour intégrer le marché du travail. La majorité des postes à pourvoir exigent en effet un bac+5 minimum, 
          les entreprises étant à la recherche de profils professionnalisés et rapidement opérationnels.<br/>
           Après avoir acquis un socle de connaissances solides en mathématiques fondamentales et appliquées et en matières scientifiques plus générales, 
          il est ainsi conseillé de vous spécialiser en Master.
                
      <br/> <br/>
          <span className='sous-title'>Plan d'études : </span>
      
       <a href="http://www.isimm.rnu.tn//storage/app/public/Plans%20des%20%C3%A9tudes/Math+%C2%AEmatique.pdf">Cliquer ici</a></p>
    ,
  },
  {
    key: '3',
    label: 'Licence TIC- Parcours: Réseaux et IOT (RIOT)',
    children: <p> 
      <span className='sous-title'>Plan d'études : </span>
      <a href="http://www.isimm.rnu.tn//storage/app/public/Plans%20des%20%C3%A9tudes/PlanDesEtudes-Licence-TIC-RIOT.pdf" target="_blank" rel="noopener"><span >Cliquer ici</span></a></p> ,
  },
  {
    key: '4',
    label: 'Licence EEA - Parcours : Systèmes Embarqués (SE) ',
    children: <p>
      <span className='sous-title'>Plan d'études : </span>
      <a href="http://www.isimm.rnu.tn//storage/app/public/Plans%20des%20%C3%A9tudes/PlanEtudes-Licence-EEA-SE.pdf" target="_blank" rel="noopener"><span >Cliquer ici</span></a></p>  ,

  },
  {
    key: '5',
    label: 'Licence EEA - Parcours: Mesure Instrumentation et Métrologie (MIM)',
    children:<p> 
      <h6>DESCRIPTION</h6> <br/>
      <span className='sous-title'>Objectifs de la formation : </span> <br/>
      Ce parcours forme des professionnels de l’instrumentation dans des domaines liés à la métrologie et les mesures : environnementales, biologiques, industrielles, médicales… L’objectif de cette formation est de former des professionnels capables de contrôler les instruments industriels (étalonnages, normes...) pour garantir une production industrielle de qualité. <br/>

      Au terme de cette formation, les diplômés auront acquis les connaissances scientifiques et organisationnelles nécessaires à l’entreprise engagée dans une démarche métrologique et sont capables :
      <ul className='descriptionul'>
        <li>d’analyser les besoins métrologiques et les documents réglementaires, techniques et normatifs</li>
        <li>de définir les procédures d’étalonnage des instruments de mesure</li>
        <li>de caractériser, de valider et d’estimer une incertitude</li>
        <li>de gérer les parcs d’instrumentation</li>
      </ul>
      <br/>
      <span className='sous-title'>Programme : </span><br/>
      Le programme est basé sur l’acquisition de compétences reconnues et recherchées par le milieu industriel :
      La formation est structurée en blocs de connaissances et de compétences ainsi qu’en unités d’enseignement.
      <br/> <br/>
      <span className='sous-title'>Debouches professionnels</span>
      <br/> 
         Métiers visés :
     <ul className='descriptionul'>
     <li>Technicien supérieur en mesures et instrumentation</li>
        <li>Technicien supérieur en qualification et métrologie industrielle</li>
        <li>Responsable d’un parc d’instrumentation</li>
        <li>Technicien référent en laboratoire d’analyse et de certification</li>
      </ul>

      <span className='sous-title'>Poursuite des études : </span><br/>
      À celles et ceux qui veulent continuer encore 2 ans, il existe de nombreux masters au sein de l’ISIMM, parmi lesquels :
      <ul className='descriptionul'>
        <li>Master professionnel en Ingénierie en Instrumentation Industrielle (3I)</li>
        <li>Master de recherche en Microélectronique & Instrumentation.</li>
     </ul>
      <span className='sous-title'>Plan d'études : </span>
      <a href="http://www.isimm.rnu.tn//storage/app/public/Plans%20des%20%C3%A9tudes/PlanEtudes-Licence-EEA-MIM.pdf" target="_blank" rel="noopener"><span >Cliquer ici</span></a></p>

  },
];
    function Licences() {
        const onChange = (key) => {
            console.log(key);
        };
    return (
        <>
        <Header/>
        
           
         <div className='containerLicence'>
        <div className='bgLicences'>  </div>
        <div className='ligne'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-304px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'70px'}}className="container-fluid text-white text-center ">Licence</h1>
          <p ><Link className='linkLicences' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkLicences'
            to="/"> Formation </Link>  <span>{'>'}</span> <Link className='linkLicences'
            to="/">Licence</Link> </p></div>
      </div>
          <div className='Collapse'>
          <div className='ligne1'>  </div>

              <Collapse  style={{ borderRadius: 0 , minWidth: '100%'}}  size="large" items={items} defaultActiveKey={['1' , '2']} onChange={onChange}   />
          </div>
       
        
        <Footer/>
        </>

    ) ;
}

export default Licences;
